module.exports = __webpack_public_path__ + "static/media/3.22a1d53d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/cei/3.mp3
// module id = 475
// module chunks = 0